﻿export default class Group {
  constructor (obj) {
    if (obj) {
      obj && Object.assign(this, obj)
      return
    }

    this.groupID = 0
    this.groupName = ''
    this.lvl = 0
    this.access_publicering = 0
    this.access_mediearkiv = 0
    this.access_produktdatabas = 0
    this.access_mailutskick = 0
    this.access_kontohantering = 0
    this.access_installningar = 0
    this.sort = 0
    this.hasChildren = false
    this.parent = 0
    this.canWrite = false
    this.isExcluded = false
  }
}
